var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyChatIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon empty-chat-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8000",
    fillRule: "evenodd",
    d: "M10.75 0c5.523 0 10 4.477 10 10 0 2.084-.638 4.02-1.729 5.622l1.68 3.523a.626.626 0 01-.691.845l-4.884-.996A9.96 9.96 0 0110.75 20c-5.523 0-10-4.477-10-10s4.477-10 10-10zm0 1.5a8.5 8.5 0 000 17 8.46 8.46 0 003.719-.854 1.5 1.5 0 01.794-.146l.163.024 3.147.642-.906-1.899a1.5 1.5 0 01.032-1.354l.082-.136A8.452 8.452 0 0019.25 10a8.5 8.5 0 00-8.5-8.5zm-4.5 9.75a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5zM16.5 10a1.25 1.25 0 11-2.5 0 1.25 1.25 0 012.5 0zm-5.75 1.25a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z"
  })));
}

export default SvgEmptyChatIconSv;